import React from 'react';
import { Instagram, Youtube, Mail, Phone } from 'lucide-react';
import { todaysVenues } from '../mySettings';

function HomePage({setActiveSection}) {
  return (
    <div className="text-center p-12 hocMid">
      <img 
        src="/img/logo.png" 
        alt="House Of Crust" 
        className="mx-auto rounded-lg mb-16 mt-16"
      />

      <h2 className='text-3xl font-bold mb-8'>Where tradition meets the streets</h2>
      <p className="text-lg text-gray-700 max-w-2xl mx-auto mb-8">
        We bring you hand-crafted, Neapolitan-inspired pizza, made fresh to order with the finest ingredients and baked to perfection in our speciality ovens.
      </p>
      <img 
        src="/img/main-directory-thumbnail_v2.jpg" 
        alt="House Of Crust" 
        className="mx-auto rounded-lg mb-16 mt-16"
      />
      <p className="text-md text-gray-700 font-bold text-2xl mb-4">
        At House of Crust, we don’t just make pizza — we craft it. 
      </p>
      <p className="text-2xl text-gray-700 text-3x1 mb-3">
        Every dough ball is hand-stretched, our sauce is made from imported Italian San Marzano tomatoes, and every bite is packed with flavor.
      </p>
      <p className="text-2xl text-gray-700 text-2x1 mb-3">
        No shortcuts, no compromises — just damn good pizza.
      </p>
      <p className="text-2xl text-gray-700 text-2x1 mb-12">
        Every slice tells a story of carefully selected ingredients, traditional techniques, and modern flavor innovations.
      </p>
      <p>
        <button 

          onClick={ ()=> {setActiveSection('menu'); window.scrollTo(0, 0)} } 
          className="text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-full text-lg px-5 py-2.5 me-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700"
        > 
          See Our Menu
        </button>
      </p>
      <br/>

      {/* <h3 className='text-2xl font-bold mb-4'>Our Pizza, Our Passion</h3>
      <p className="text-md text-gray-700 max-w-2xl mx-auto mb-12">
        Every slice tells a story of carefully selected ingredients, traditional techniques, and modern flavor innovations.
      </p> 
      <h3 className='text-2xl font-bold mb-4'>Street Food with Soul</h3>
      <p className="text-md text-gray-700 max-w-2xl mx-auto mb-12">
        We keep things simple: top-tier ingredients, traditional techniques, and a whole lot of love. Whether you find us at your favorite market, festival, or private event, we’re slinging pies that are crispy, chewy, and packed with bold, honest flavors.
      </p>
       */}

      {/* <h2 className='text-3xl  mb-1 mt-8'>Find us at <span className="font-bold">{todaysVenues[0].venue.label}</span> on <span className="font-bold">{todaysVenues[0].day} {todaysVenues[0].date}</span></h2>
      <img
        src={todaysVenues[0].venue.img.src}
        alt={todaysVenues[0].venue.img.alt}
        className="mx-auto rounded-lg mb-2 mt-4"
      />
      <div  className="text-center p-4 hocMid mb-16">
        <iframe 
          title={todaysVenues[0].venue.label + ' map location'}
          src={todaysVenues[0].venue.map.googleMaps} 
          width="600" 
          height="450" 
          style={{"border":0, "align":"center", "width": "50%", "marginLeft": "25%"}} 
          allowFullScreen="" 
          loading="lazy" 
          referrerPolicy="no-referrer-when-downgrade" 
        />
      </div> */}
{/* 
      <h3 className='text-2xl font-bold mb-4'>Follow Us</h3>
      <div className="container mx-auto flex justify-center items-center mb-4">
        <div className="flex space-x-4">
          <a href="#" className="hover:text-amber-500">
            <Youtube  size={69} />
          </a>
          <a href="#" className="hover:text-amber-500">
            <Instagram   size={62} />
          </a>
        </div>
      </div>
       */}
      {/* <div className="container mb-12">
        <p  className='text-2xl mb-2'>We give a <span className="font-bold">10% discount</span> to our followers</p>
        <p>Keep updated on where we are, what pizzas were are offering today, recipes, news and a look behind the scenes</p>
      </div> */}

      <h3 className='text-2xl font-bold mb-4'>Private Hire & Events</h3>
      <p className='text-2xl mb-2'>Want House of Crust at your party, wedding, or corporate event?</p>
      <p className='text-1xl  font-bold   mb-2'> We bring the full pizza experience to you!. </p>
      <p className='mb-4'>Get in touch, and let’s make your event delicious.</p>
      <div className="container mx-auto flex justify-center items-center mb-4">
        <div className="flex space-x-4">
          <a href="mailto:info@houseofcrust.co.uk" className="hover:text-amber-500">
            <Mail size={36} />              
          </a>
          <a href="tel:07967148166" className="hover:text-amber-500">
            <Phone size={36} />              
          </a>
        </div>
      </div>

      {/* <div className="flex justify-center space-x-4 mt-6">
        <div className="text-center">
          <Star className="mx-auto text-yellow-500" size={40} />
          <p className="mt-2">Premium Ingredients</p>
        </div>
        <div className="text-center">
          <Pizza className="mx-auto text-red-500" size={40} />
          <p className="mt-2">Artisan Crafted</p>
        </div>
      </div> */}

    </div>
  );
}

export default HomePage;
